var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"main-wrapper-website position-relative"},[_c('HeaderPage'),_c('AppMain'),_c('MobBottomNav')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }